var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalLinkBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "external-link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C12.553,3 13,3.448 13,4 C13,4.552 12.553,5 12,5 L12,5 L6,5 C5.448,5 5,5.449 5,6 L5,6 L5,18 C5,18.551 5.448,19 6,19 L6,19 L18,19 C18.552,19 19,18.551 19,18 L19,18 L19,12 C19,11.448 19.447,11 20,11 C20.553,11 21,11.448 21,12 L21,12 L21,18 C21,19.654 19.654,21 18,21 L18,21 L6,21 C4.346,21 3,19.654 3,18 L3,18 L3,6 C3,4.346 4.346,3 6,3 L6,3 Z M16.0051,3 L20.0021,3.02 C20.5521,3.023 20.9971,3.469 20.9971,4.019 L20.9971,4.019 L21.0001,7.999 C21.0001,8.552 20.5531,9 20.0011,9 L20.0011,9 C19.4481,9 19.0001,8.553 19.0001,8.001 L19.0001,8.001 L18.9991,6.415 L12.7071,12.707 C12.5121,12.902 12.2561,13 12.0001,13 C11.7441,13 11.4881,12.902 11.2931,12.707 C10.9021,12.316 10.9021,11.684 11.2931,11.293 L11.2931,11.293 L17.5781,5.008 L15.9951,5 C15.4421,4.997 14.9971,4.547 15.0001,3.995 C15.0031,3.444 15.4501,3 16.0001,3 L16.0001,3 L16.0051,3 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "external-link",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#0056D7",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkBlue);
export default __webpack_public_path__ + "static/media/external-link-blue.ecf0cc91f6c84db65ad0bd762006e0bb.svg";
export { ForwardRef as ReactComponent };